<template>
  <!-- 打卡汇总 -->
  <div class="clockInRecord">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <ExportExcelDaka :info="tableData" />
      <!-- <el-button type="primary" size="mini" icon="el-icon-download" @click="derive">导出汇总表</el-button> -->
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="账号：" prop="username">
        <el-input v-model="screenForm.username" />
      </el-form-item>
      <el-form-item label="真实姓名：" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-form-item label="联系方式：" prop="contact">
        <el-input v-model="screenForm.contact" />
      </el-form-item>
      <el-form-item label="月份：" prop="month">
        <el-input v-model="screenForm.month" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData"> 筛选 </el-button>
    </el-form>
    <!-- 列表 -->
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="month" label="月份" />
        <el-table-column prop="company.username" label="账号" />
        <el-table-column prop="company.name" label="真实姓名" />
        <el-table-column prop="company.contact" label="联系方式" />
        <el-table-column prop="attendance" label="出勤天数" />
        <el-table-column prop="ops" label="外勤" />
        <el-table-column prop="missCards" label="缺卡" />
      </el-table>
      <!-- 分页 -->
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import ExportExcelDaka from '@/components/ExportExcelDaka/collectExcel.vue'
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  components: { ExportExcelDaka },
  data() {
    return {
      screenForm: {
        username: '',
        name: '',
        contact: '',
        month: ''
      },
      loading: true,
      tableData: [],
      tableH: 0,
      ids: [] // 批量选中的账号
    }
  },
  mounted() {
    this.getTableList() // 获取企业打卡管理列表
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 刷新
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {})
    },
    // 导出考勤表
    derive() {},
    // 筛选
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {})
    },
    // 打卡汇总列表
    getTableList() {
      this.loading = true
      return this.$api.clockIn
        .getPunchTotalsList(this.page)
        .then((res) => {
          console.log(res)
          this.tableData = res.records
          this.total = res.total
          const ids = this.tableData
            .filter((item) => item.companyAccountId)
            .map((item) => item.companyAccountId)
            .join(',')
          this.getFindCompanyByIds({ ids }) // 所在公司
          this.getCompanyList({ ids }) // 账号管理ids接口
        })
        .catch((e) => {})
    },
    // 账号管理ids接口
    getCompanyList(data) {
      this.$api.clockIn
        .getPunchAccountIds(data)
        .then((res) => {
          let arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          console.log(res)
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 所在公司
    getFindCompanyByIds(data) {
      this.$api.common
        .reqCompanyAccountByIds(data)
        .then((res) => {
          console.log(res)
          let arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          // const companyList = res
          const settingObj = res
          const settingArr = Object.keys(settingObj).map((key) => {
            // console.log(key); //为每个键名
            console.log(settingObj)
            return settingObj[key] // 把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          })
          console.log(settingArr)
          const companyList = settingArr
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyAccountId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 批量选中
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
      // console.log(this.ids)
    }
  }
}
</script>

<style lang="scss" scoped>
.clockInRecord {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
